export default __webpack_public_path__ + "static/media/tooltip.0928a41a.svg";